// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* UserFormModal.module.scss */
.UserFormModal_modalOverlay__BPuD3 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px;
}

.UserFormModal_modalContent__m5Pke {
  background-color: white;
  padding: 16px;
  border-radius: 10px;
  width: 420px;
  max-width: 100%;
}
.UserFormModal_modalContent__m5Pke h2 {
  margin-bottom: 14px;
}
.UserFormModal_modalContent__m5Pke input {
  display: block;
  width: 100%;
  padding: 10px 10px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 8px;
}

.UserFormModal_label__vz-4G {
  font-size: 12px;
  opacity: 0.75;
  margin-bottom: 6px;
  display: block;
}

.UserFormModal_buttons__hzEZy {
  display: flex;
  gap: 10px;
  margin-top: 12px;
}
.UserFormModal_buttons__hzEZy button {
  flex: 1 1;
  padding: 10px 12px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}
.UserFormModal_buttons__hzEZy button[type=submit] {
  background-color: #007bff;
  color: white;
}
.UserFormModal_buttons__hzEZy button[type=submit]:hover {
  background-color: #0056b3;
}
.UserFormModal_buttons__hzEZy button[type=button] {
  background-color: #6c757d;
  color: white;
}
.UserFormModal_buttons__hzEZy button[type=button]:hover {
  background-color: #5a6268;
}

@media (max-width: 480px) {
  .UserFormModal_modalContent__m5Pke {
    width: 100%;
    padding: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/UsersPage/UserFormModal.module.scss"],"names":[],"mappings":"AAAA,8BAAA;AACA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AACF;;AAEA;EACE,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;AACF;AACE;EACE,mBAAA;AACJ;AAEE;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;AAAJ;;AAIA;EACE,eAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;AADF;;AAIA;EACE,aAAA;EACA,SAAA;EACA,gBAAA;AADF;AAGE;EACE,SAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AADJ;AAGI;EACE,yBAAA;EACA,YAAA;AADN;AAGM;EACE,yBAAA;AADR;AAKI;EACE,yBAAA;EACA,YAAA;AAHN;AAKM;EACE,yBAAA;AAHR;;AASA;EACE;IACE,WAAA;IACA,aAAA;EANF;AACF","sourcesContent":["/* UserFormModal.module.scss */\r\n.modalOverlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 12px;\r\n}\r\n\r\n.modalContent {\r\n  background-color: white;\r\n  padding: 16px;\r\n  border-radius: 10px;\r\n  width: 420px;\r\n  max-width: 100%;\r\n\r\n  h2 {\r\n    margin-bottom: 14px;\r\n  }\r\n\r\n  input {\r\n    display: block;\r\n    width: 100%;\r\n    padding: 10px 10px;\r\n    margin-bottom: 10px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 8px;\r\n  }\r\n}\r\n\r\n.label {\r\n  font-size: 12px;\r\n  opacity: 0.75;\r\n  margin-bottom: 6px;\r\n  display: block;\r\n}\r\n\r\n.buttons {\r\n  display: flex;\r\n  gap: 10px;\r\n  margin-top: 12px;\r\n\r\n  button {\r\n    flex: 1;\r\n    padding: 10px 12px;\r\n    border: none;\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n\r\n    &[type='submit'] {\r\n      background-color: #007bff;\r\n      color: white;\r\n\r\n      &:hover {\r\n        background-color: #0056b3;\r\n      }\r\n    }\r\n\r\n    &[type='button'] {\r\n      background-color: #6c757d;\r\n      color: white;\r\n\r\n      &:hover {\r\n        background-color: #5a6268;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .modalContent {\r\n    width: 100%;\r\n    padding: 14px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `UserFormModal_modalOverlay__BPuD3`,
	"modalContent": `UserFormModal_modalContent__m5Pke`,
	"label": `UserFormModal_label__vz-4G`,
	"buttons": `UserFormModal_buttons__hzEZy`
};
export default ___CSS_LOADER_EXPORT___;
